var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoScheduleActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ldp1hz0d3a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.662745 0 0 0 0 0.992157 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: ""
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.801 18.106V8.931c0-2.061-1.67-3.732-3.732-3.732H6.732A3.732 3.732 0 0 0 3 8.931v16.133c0 2.061 1.67 3.732 3.732 3.732h11"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M10.503 3v4.399M21.298 3v4.399"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M9.067 15.783H12.1V12.75H9.067zM9.067 22.067H12.1v-3.034H9.067zM14.483 15.783h3.034V12.75h-3.034zM14.483 22.067 16.5 22l1.017-2.967h-3.034zM19.9 15.783h3.033V12.75H19.9z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 23.5a7.5 7.5 0 1 1-7.499-7.5A7.498 7.498 0 0 1 31 23.5z",
    stroke: "#FFFFFF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    d: "M20 23.5h7M23.5 20v7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoScheduleActive);
export default __webpack_public_path__ + "static/media/PictoScheduleActive.30836806e478fe8f77959e7f442abb0c.svg";
export { ForwardRef as ReactComponent };